import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-become-creator-values" }
const _hoisted_2 = { class: "_flexwrap _tac _jc-c" }
const _hoisted_3 = { class: "_py-4 _tac" }
const _hoisted_4 = { "data-qa": "create-account-button:BecomeCreator" }
const _hoisted_5 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_become_a_creator_values_title = _resolveComponent("become-a-creator-values-title")
  const _component_values_section_item = _resolveComponent("values-section-item")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, { huge: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_become_a_creator_values_title),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.benefits, (value) => {
            return (_openBlock(), _createBlock(_component_values_section_item, {
              key: value.valueID,
              title: value.title,
              description: value.description,
              "value-i-d": value.valueID,
              class: "gfu-1of2 gfu-1of4--m _pa-4"
            }, null, 8 /* PROPS */, ["title", "description", "value-i-d"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: $props.createCreatorAccountUrl,
              class: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--wide _ttu"
            }, " Launch your project ", 8 /* PROPS */, _hoisted_5)
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}